export default __webpack_public_path__ + "static/img67h-9f4c13aefa16d48fd6aea339a794d54b.jpg";